import { useQuery } from '@tanstack/react-query'

import { getSurveysDefinition } from '~/services/survey-services'

export function useGetSurveyDefinitionByUser(enabled = true) {
  return useQuery({
    queryKey: ['surveyDefinitionByUser'],
    queryFn: async () => await getSurveysDefinition(),
    enabled,
  })
}
